module.exports = __webpack_public_path__ + "img/thumbnail-upload-image-default.8b240e1c.svg";